import React from "react";
import Nav2 from "../Components/nav2/Nav2";
import Contact from "../Components/contact/Contact";
import Footer from "../Components/footer/Footer";

const Bolg = () => {
  return (
    <>
      <Nav2 />
      <div>Bolg En developpement</div>
      <Contact />
      <Footer />
    </>
  );
};

export default Bolg;
